"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Flag(_a) {
    var _b, _c;
    var dataKey = _a.dataKey, onClick = _a.onClick, props = __rest(_a, ["dataKey", "onClick"]);
    var key = props.key, cx = props.cx, fill = props.fill, yAxis = props.yAxis;
    function handleClick() {
        if (!onClick) {
            return;
        }
        onClick(props);
    }
    var data = Object.keys(props.payload).reduce(function (p, c) {
        if (!c.includes(dataKey + "-data")) {
            return p;
        }
        return props.payload[dataKey + "-data"];
    }, null);
    if (!data) {
        return null;
    }
    return (react_1.default.createElement("svg", { key: key, x: cx - 168.18, y: 0, onMouseOut: function (e) { return e.target.style.cursor = 'default'; }, onMouseOver: function (e) { return e.target.style.cursor = 'pointer'; } },
        react_1.default.createElement("line", { stroke: ((_b = data.meta) === null || _b === void 0 ? void 0 : _b.color) || fill, x1: 168.18, x2: 168.18, y1: 114.75, y2: yAxis.height + 20, "stroke-width": 3 }),
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { width: 40, height: 33, textRendering: "hey", fill: ((_c = data.meta) === null || _c === void 0 ? void 0 : _c.color) || fill, y: 113.75, x: 167.18, "stroke-width": 1.5, onClick: handleClick }),
            react_1.default.createElement("text", { x: 167.18 + 15, y: 135.18, "font-family": "Verdana", "font-size": "16", fill: "black" }, data.value))));
}
exports.Flag = Flag;
//# sourceMappingURL=Flag.js.map